import type { FwTag } from '@mathflat/shared/@modules/errorReporting'

import type { Academy, User } from '@/dto'

export type ReportPlatform = 'web' | 'desktop' | 'webview'
export type ReportBrand = 'mathflat' | 'schoolflat'

export type ReportUserContext = {
  id: string
}

// 에러 이벤트에 함께 실리는 값은 여기 열거한 것뿐이다. 객체를 통째로 넘기면 DTO 에 나중에 추가되는
// 필드(이메일·전화번호 등)까지 따라 나가므로, 재현에 필요한 식별자와 구분값만 allowlist 로 고정한다.
export type ReportFwContext = {
  brand: ReportBrand
  platform: ReportPlatform
  userRole: User['type']
  academyId: Academy['academyId']
}

export const resolveReportPlatform = ({
  isElectron,
  isAppWebview,
}: {
  isElectron: boolean
  isAppWebview: boolean
}): ReportPlatform => {
  if (isElectron) return 'desktop'
  if (isAppWebview) return 'webview'
  return 'web'
}

export const buildReportContext = ({
  user,
  academy,
  isSchoolflat,
  platform,
}: {
  user: User
  academy: Academy
  isSchoolflat: boolean
  platform: ReportPlatform
}): { user: ReportUserContext; fw: ReportFwContext } => ({
  user: { id: String(user.teacherId) },
  fw: {
    brand: isSchoolflat ? 'schoolflat' : 'mathflat',
    platform,
    userRole: user.type,
    academyId: academy.academyId,
  },
})

// academyId 는 선택값이라 String() 으로 감싸면 "undefined" 라는 학원 id 태그가 생긴다. 없으면 태그를 뺀다.
export const toReportTags = (fw: ReportFwContext): Partial<Record<FwTag, string>> => ({
  'fw.brand': fw.brand,
  'fw.platform': fw.platform,
  'fw.user.role': fw.userRole,
  ...(fw.academyId === undefined ? {} : { 'fw.academy.id': String(fw.academyId) }),
})
